import { Chip } from "@heroui/react";
import { useTranslation } from "react-i18next";

function ApplyNChip() {
    const { t } = useTranslation();
    return (
        <Chip
            classNames={{
                base: "bg-red-100 font-bold",
                content: "font-bold text-red-700",
            }}
            radius="sm"
            size="sm"
        >
            {t("apply_n", { ns: "fields-list" })}
        </Chip>
    );
}

export default ApplyNChip;
